var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadFileRgbRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dhl_icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H8V44H40V16H28Zm2,24H26v7H22V28H18l6-7ZM40,14H30V4Z",
    fill: "#d70511"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFileRgbRed);
export default __webpack_public_path__ + "static/media/upload_file_rgb_red.76517ba38bcea08876d0bc9e6780dfe4.svg";
export { ForwardRef as ReactComponent };